import { Button } from "@/components/ui/button";
import * as z from "zod";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  // FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useSendOtpMutation } from "@/lib/services/data-layer/core";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { FC } from "react";
import { OtpAction } from "@/pages/auth/otp/otp-reducer";
import FormattedNumberInput from "@/components/v-pos/inputs/formatted-number-input.component";
import { toast } from "react-toastify";
import { Label } from "@/components/ui/label";

const phoneSchema = z.object({
  phoneNumber: z
    .string()
    .length(11, "شماره تلفن باید 11 کاراکتر باشد")
    .regex(/^[0-9]{0,11}$/, "شماره موبایل باید فقط شامل اعداد باشد"),
});

interface PhoneFormValues {
  phoneNumber: string;
}

type SendOtpFormProps = {
  dispatch: React.ActionDispatch<[action: OtpAction]>;
  phoneNumber?: string;
  timer: number;
};

const SendOtpForm: FC<SendOtpFormProps> = ({
  phoneNumber = "",
  timer,
  dispatch,
}) => {
  const { mutate, isPending } = useSendOtpMutation();

  const phoneForm = useForm<PhoneFormValues>({
    resolver: zodResolver(phoneSchema),
    defaultValues: {
      phoneNumber,
    },
    reValidateMode: "onChange",
    mode: "onChange",
  });

  const onPhoneSubmit = ({ phoneNumber }: PhoneFormValues) => {
    if (timer > 0) return dispatch({ type: "SET_STEP", payload: "verify" });

    mutate(
      {
        mobile: phoneNumber,
      },
      {
        onSuccess: () => {
          dispatch({
            type: "SET_PHONE_NUMBER",
            payload: phoneNumber,
          });
        },
        onError: (err) => {
          toast.error(err?.message);
        },
      }
    );
  };

  return (
    <Form {...phoneForm}>
      <form
        onSubmit={phoneForm.handleSubmit(onPhoneSubmit)}
        // className="space-y-[20px]"
      >
        <FormField
          control={phoneForm.control}
          name="phoneNumber"
          render={({ field }) => (
            <FormItem className="gap-y-[18px] items-center flex flex-col w-full">
              <Label
                htmlFor={field.name}
                className="text-base mr-[4px] flex text-gray-500"
              >
                لطفا شماره موبایل خود را وارد نمایید.
              </Label>
              <FormControl>
                <FormattedNumberInput
                  id={field.name}
                  placeholder="09*********"
                  inputMode="numeric"
                  maxLength={11}
                  {...field}
                  className="text-[18px] text-center ltr tracking-[0.2em] rounded-2xl"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <Button
          type="submit"
          className="w-full mb-3 mt-[40px] rounded-2xl"
          // disabled={!phoneForm.formState.isValid || isPending}
        >
          {isPending ? "درحال ارسال..." : "دریافت کد ورود"}
        </Button>
      </form>
    </Form>
  );
};

export default SendOtpForm;
